module.exports = __webpack_public_path__ + "media/recipes/114-40b6c5f2.png";